import React, { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useDispatch } from 'react-redux';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import List from 'core/modules/Partials/List/List';
import MerchantTileListItem from 'core/modules/MerchantTileList/components/MerchantTileListItem/MerchantTileListItem';

import { triggerCuratedActiveMerchantsAreViewed } from './actions';
import defaultSettings from './configs';

import './CuratedActiveMerchants.scss';

function CuratedActiveMerchants({ merchant }) {
  const dispatch = useDispatch();
  const { maxRelatedActiveMerchants } = defaultSettings;
  const { relatedActiveMerchants, relatedMerchantsHeadline = '' } = merchant;

  const relatedActiveMerchantsToDisplay =
    (relatedActiveMerchants && relatedActiveMerchants.slice(0, maxRelatedActiveMerchants)) || [];

  useEffect(() => {
    if (!isEmpty(relatedActiveMerchantsToDisplay)) {
      const { name: suspendedMerchantName } = merchant;
      dispatch(triggerCuratedActiveMerchantsAreViewed(relatedActiveMerchantsToDisplay, suspendedMerchantName));
    }
  }, []);

  if (isEmpty(relatedActiveMerchantsToDisplay)) {
    return (null);
  }

  return (
    <div className="mn_curatedActiveMerchants" data-test="curated-active-merchants">
      <SectionTitle title={relatedMerchantsHeadline} />
      <List shouldUseCarousel>
        {relatedActiveMerchantsToDisplay.map(merchant => (
          <MerchantTileListItem
            key={merchant.id}
            merchant={merchant}
            label="Extra"
          />
        ))}
      </List>
    </div>
  );
}

CuratedActiveMerchants.defaultProps = {
  merchant: {},
};

export default (props) =>
  <ComponentErrorBoundary><CuratedActiveMerchants {...props} /></ComponentErrorBoundary>;
